import React from "react";
import DatePickerController from "../datePickerController";
import { ASSESSMENT_FIELD_LABELS } from "../../utils/assessmentAdminFieldConfig";
import { formatMaybeInvalidDate } from "../../utils/assessmentAdminFormHelpers";
import AssessmentAdminExtraDateRows from "./AssessmentAdminExtraDateRows";

/**
 * Observation date rows shown when Observation Report Needed is Yes.
 */
export default function AssessmentAdminCapaObservationDates({
  vqa,
  updateActive,
  control,
  dateFormat,
}) {
  const vendorDelivered = vqa?.draft_report_delivered_to_provider_on;
  const sponsorDelivered = vqa?.capa_delivered_to_sponsor_on;

  return (
    <>
      <div className="px-0 py-4">
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <h2 className="text-sm font-medium text-gray-900">
            {ASSESSMENT_FIELD_LABELS.observationReportDeliveredToVendor}
          </h2>
          <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
            <span>
              {updateActive ? (
                <DatePickerController
                  control={control}
                  fieldName={"draftDelieveredToVendorDate"}
                  value={vendorDelivered}
                  disableMinDate={true}
                />
              ) : vendorDelivered !== null && vendorDelivered !== undefined ? (
                dateFormat(vendorDelivered)
              ) : (
                "-"
              )}
            </span>
          </p>
        </div>
      </div>
      <div className="px-0 py-4">
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <h2 className="text-sm font-medium text-gray-900">
            Observation Report Delivered to Sponsor
          </h2>
          <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
            <span>
              {updateActive ? (
                <DatePickerController
                  control={control}
                  fieldName={"capaDelieveredToSponsorDate"}
                  value={sponsorDelivered}
                  disableMinDate={true}
                />
              ) : vqa != null && sponsorDelivered ? (
                formatMaybeInvalidDate(sponsorDelivered, dateFormat)
              ) : (
                "-"
              )}
            </span>
          </p>
        </div>
      </div>
      <AssessmentAdminExtraDateRows
        section="observation"
        vqa={vqa}
        updateActive={updateActive}
        control={control}
        dateFormat={dateFormat}
      />
    </>
  );
}
